import { RegisteredComponent } from "@builder.io/sdk-react";
import {
  DLD_FIELD,
  DLT_FIELD,
  LEGACY_HREF_FIELD,
  THEME_FIELD,
  TITLE_FIELD,
} from "../commonFields";

export const SWDCGlobalSimpleFooterBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "SWDC Global Simple Footer",
  noWrap: true,
  models: ["page-footer"],
  inputs: [
    {
      ...THEME_FIELD,
      defaultValue: "gray",
      enum: [
        {
          label: "gray",
          value: "gray",
        },
        {
          label: "black",
          value: "black",
        },
        {
          label: "white",
          value: "white",
          helperText: "New redesigned version",
        },
      ],
    },
    {
      name: "animatedTopLine",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Animated Top Line",
      showIf: (options) => options.get("theme") === "white",
    },
    {
      name: "legal_links",
      type: "list",
      friendlyName: "Legal Links",
      subFields: [
        { ...TITLE_FIELD, required: true },
        { ...LEGACY_HREF_FIELD, required: true },
        { ...DLT_FIELD, required: false },
        { ...DLD_FIELD, required: false },
        {
          name: "isDoNotSellLink",
          type: "boolean",
          defaultValue: false,
          helperText:
            "Enable this to make the link a button with custom onclick action",
        },
        {
          name: "doNotSellAriaLabel",
          type: "string",
          localized: true,
        },
      ],
      defaultValue: [
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Legal Documents",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "https://www.solarwinds.com/legal/legal-documents",
          },
          dlt: "Footer",
          dld: "Legal Documents link",
        },
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Privacy",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "https://www.solarwinds.com/legal/privacy",
          },
          dld: "Privacy link",
          dlt: "Footer",
        },
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "California Privacy Rights",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default:
              "https://www.solarwinds.com/legal/privacy#california-privacy-rights",
          },
          dld: "California Privacy Rights link",
          dlt: "Footer",
        },
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Web Accessibility Statement",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "https://www.solarwinds.com/web-accessibility-statement",
          },
          dld: "Web Accessibility Statement link",
          dlt: "Footer",
        },
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Do Not Sell My Information",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "",
          },
          dlt: "Footer",
          dld: "Do Not Sell link",
          isDoNotSellLink: true,
          doNotSellAriaLabel: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Do Not Sell My Information",
          },
        },
      ],
    },
    {
      name: "copyright",
      type: "string",
      localized: true,
      required: false,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "©2025 SolarWinds Worldwide, LLC. All rights reserved.",
      },
    },
  ],
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flexShrink: "0",
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "var(--color-background,#ffffff)",
  },
  canHaveChildren: false,
};
